







































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
@Component({
    components: {},
}) 
export default class pdTipPanel extends Vue {
   
    public $refs!: {
       
    };

    show=false;

    isAll=false;

    async mounted() {
        
    }
    async created() {
    
    }
    showFun(val){
        this.isAll = val;
        this.show = true;
    }
    closeFun(){
        this.show = false;
    }
    confirmFun(){
        this.$emit('onSave')
        this.show = false;
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/components/pdTipPanel.vue